export default {

  init(){

    $('.thumb-list a').fancybox();

  },

  finalize(){



  },

};



// WEBPACK FOOTER //
// ./scripts/routes/singleproduct.js